import BillingsOrderForwardTaxiTaxiDraftRequest from "../../../../../api/raily/billings/order-forward/taxi-taxi/draft/billings-order-forward-taxi-taxi-draft.request";
import BillingsOrderForwardTaxiTaxiDraftParams from "./billings-order-forward-taxi-taxi-draft-params";

const create = (
  params: BillingsOrderForwardTaxiTaxiDraftParams,
): BillingsOrderForwardTaxiTaxiDraftRequest => {
  return {
    forwardingId: params.forwardingId,
  };
};

const billingOrderForwardTaxiTaxiDraftParamsFactory = {
  create,
};

export default billingOrderForwardTaxiTaxiDraftParamsFactory;
